import React,{useState} from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import Dropdown from './Dropdown'
 
function Menu(props) {
 
  const { menuLinks } = props.data.site.siteMetadata;
  const [dropdown, setDropdown] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const onClick = () => setIsActive(!isActive)
  return (
        
  
  //return (
        
    <div id="main-menu" className="main-menu">
       <ul>
        {/* {menuLinks.map(link => (
          <li key={link.name}>
            <Link to={link.link}>{link.name}</Link>
          </li>
            
        ))} */}
       <li>
         <Link to="/intro">INTRO</Link>
       </li>
       <li>
         <Link to="/" onClick={onClick}> EXPLORE</Link>
         <ul className="dropdown-menu-oneaction">
                  <li>  <Link to="/intro">Intro</Link> </li>
                  <li> <Link to="/constitution"> Constitution</Link> </li>
                  <li> <Link to="/digital-democracy"> Digital Democracy</Link> </li>
                  <li> <Link to="/tally-up"> Tally Up</Link> </li>
                  <li> <Link to="/funding"> Funding</Link> </li>
                  <li> <Link to="/roadmap"> Roadmap</Link> </li>
         </ul>
       </li>
       <li>
         <Link to="/tally-up">JOIN</Link>
       </li>
       <li>
         <Link to="/contact">CONTACT</Link>
       </li>
       <li>
         <Link to="/faq">FAQ</Link>
       </li>
       <li>
         <Link to="/team"> TEAM</Link>
       </li>
       <li>
         <Link to="/posts">POSTS</Link>
       </li>
      </ul>
    </div>

/* <div className="btn-group">
  <button  type="button" className="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Action
  </button>
  <div className="dropdown-menu">
    <a className="dropdown-item" href="#">Action</a>
    <a className="dropdown-item" href="#">Another action</a>
    <a className="dropdown-item" href="#">Something else here</a>
    <div className="dropdown-divider"></div>
    <a className="dropdown-item" href="#">Separated link</a>
  </div> */

  
  );
};

export default props => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            menuLinks {
              name
              link
            }
          }
        }
      }
    `}
    render={data => <Menu data={data} />}
  />
);

